import { render, staticRenderFns } from "./StdCard.vue?vue&type=template&id=2373268a&"
import script from "./StdCard.vue?vue&type=script&lang=js&"
export * from "./StdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports